import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/projects-cta.scss';
import star from '../assets/images/star.png';
import Seo from '../assets/svg/seo.svg';
import Web from '../assets/svg/web.svg';
import Increase from '../assets/svg/increase.svg';
import Launch from '../assets/svg/launch.svg';

const ProjectsCTA = () => {
  const { t } = useTranslation();

  const projectTiles = [
    {
      title: t('projectsCta.tile1_title'),
      tag: t('projectsCta.tile1_tag'),
      icon: (
        <img src={Seo} alt="SEO" className="projects-cta__icon-img" />
      ),
    },
    {
      title: t('projectsCta.tile2_title'),
      tag: t('projectsCta.tile2_tag'),
      icon: (
        <img src={Web} alt="Web" className="projects-cta__icon-img" />
      ),
    },
    {
      title: t('projectsCta.tile3_title'),
      tag: t('projectsCta.tile3_tag'),
      icon: (
        <img src={Increase} alt="Increase" className="projects-cta__icon-img" />
      ),
    },
    {
      title: t('projectsCta.tile4_title'),
      tag: t('projectsCta.tile4_tag'),
      icon: (
        <img src={Launch} alt="Launch" className="projects-cta__icon-img" />
      ),
    },
  ];

  return (
    <section className="projects-cta" id="services">
      <div className="section-shell">
        <div className="projects-cta__content">
        <p className="projects-cta__label">{t('projectsCta.label')}</p>
        <h2>{t('projectsCta.title')}</h2>
        <p>
          {t('projectsCta.description')}
        </p>
        <a className="projects-cta__button" href="/services">
          <span className="btn__icon">
            <img src={star} alt="" />
          </span>
          <span>{t('projectsCta.button')}</span>
        </a>
        </div>

        <div className="projects-cta__grid">
          {projectTiles.map((project) => (
            <a className="projects-cta__tile" key={project.title}>
              <span className="projects-cta__icon" aria-hidden="true">
                {project.icon}
              </span>
              <div>
                <p>{project.title}</p>
                <span>{project.tag}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsCTA;
